import { createContext, useContext } from 'react';

type ContactDetailsDrawerContextValue = {
  openContactDetails: (
    contactId: string,
    tab?: 'details' | 'signals' | 'company',
    signalTab?: 'website' | 'market' | 'linkedin'
  ) => void;
  closeContactDetails: () => void;
};

export const ContactDetailsDrawerContext = createContext<ContactDetailsDrawerContextValue | null>(
  null
);

export const useContactDetailsDrawer = () => useContext(ContactDetailsDrawerContext);
